// Reuse the browser's persisted device ID. If storage is blocked, use an
// opaque page-session ID for checkout only; do not alter signup device checks.
let pageDeviceId = '';

export const getPaymentDeviceId = (persistedDeviceId) => {
  const existing = String(persistedDeviceId || '');
  if (existing.length > 0 && existing.length <= 128 && !/[\x00-\x20\x7f]/.test(existing)) return existing;
  if (!pageDeviceId) {
    pageDeviceId = typeof globalThis.crypto?.randomUUID === 'function'
      ? globalThis.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
  }
  return pageDeviceId;
};
